<mat-card>
    <mat-card-title>Novo Usuário</mat-card-title>
    <form>
        <mat-form-field>
            <input matInput placeholder="Nome completo *" name="name" [(ngModel)]="user.name">
        </mat-form-field>
        <mat-form-field>
            <input autocomplete="new-email" type="email" matInput placeholder="E-mail *" name="email" [(ngModel)]="user.email">
        </mat-form-field>
        <mat-form-field>
            <mat-label>Senha *</mat-label>
            <input matInput [type]="hide ? 'password' : 'text'" placeholder="Senha" name="password"
                [(ngModel)]="senha1">
            <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'"
                [attr.aria-pressed]="hide">
                <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Confirme sua senha *</mat-label>
            <input matInput [type]="hide ? 'password' : 'text'" placeholder="confirmar senha" name="password"
                [(ngModel)]="senha2">
            <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'"
                [attr.aria-pressed]="hide">
                <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
        </mat-form-field>
    </form>
    <button mat-raised-button (click)="createUser()" color="primary">
        Salvar
    </button>
    <button mat-raised-button (click)="cancel()">
        Cancelar
    </button>
</mat-card>